
























import { Vue, Component, Prop } from 'vue-property-decorator'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import { ButtonSize, ButtonTheme } from '@/utils/ButtonAttr'
import TranslationModule from '@/utils/TranslationModule'

@Component({
    components: { BaseButton },
})
export default class ModalOnboardingContactPartner extends Vue {
    @Prop({ type: String, default: 'modal-onboarding-contact-partner' }) name!: string
    TranslationModule = TranslationModule
    ButtonSize = ButtonSize
    ButtonTheme = ButtonTheme
}
